// §11.1 / §9.1 — File Explorer as an in-process app.
//
// `multiWindow`, because two folders side by side is the whole point of a file manager — and
// D-057's `unmount(container)` exists precisely so the second window can be closed on its own.
import { createRoot, type Root } from 'react-dom/client';
import type { ExplorerShellAccess, InProcessApp } from '@hangar/shared';
import { COPY } from '@/copy';
import { Explorer } from './Explorer';
import './explorer.css';

const roots = new WeakMap<HTMLElement, Root>();

export function createExplorerApp(access: ExplorerShellAccess): InProcessApp {
  return {
    id: 'explorer',
    name: 'File Explorer',
    icon: { glyph: 'folder', hue: 45 },
    keywords: ['files', 'folder', 'browse', 'finder', 'documents'],
    window: { width: 900, height: 600, minWidth: 520, minHeight: 360, multiWindow: true },
    // §9.2 — what the Windows taskbar offers on a right-click (D-100).
    jumpList: [{ id: 'new-window', label: COPY.explorer.newWindow }],

    onCommand(commandId, api) {
      if (commandId === 'new-window') void api.launch.app('explorer');
    },

    mount(container, api) {
      const root = createRoot(container);
      roots.set(container, root);
      root.render(<Explorer api={api} access={access} />);
    },

    unmount(container) {
      const root = roots.get(container);
      roots.delete(container);
      root?.unmount();
    },
  };
}
